import { useMutation } from "@apollo/client";
import { graphql } from "../gql";
import { GetAllOneOnOneAssignmentPdfsQuery } from "./useAllOneOnOneAssignmentPdfs.ts";
import {
  BusinessEnglishObjective,
  OneOnOneLessonType,
  SpeakingClassLevel,
} from "../gql/graphql.ts";

const DeleteOneOnOneAssignmentPdfMutation = graphql(`
  mutation deleteOneOnOneAssignmentPdf(
    $assignmentNumber: Int!
    $level: SpeakingClassLevel!
    $oneOnOneLessonType: OneOnOneLessonType!
    $userGroupId: String!
    $businessEnglishObjective: BusinessEnglishObjective
  ) {
    deleteOneOnOneAssignmentPdf(
      assignmentNumber: $assignmentNumber
      level: $level
      oneOnOneLessonType: $oneOnOneLessonType
      userGroupId: $userGroupId
      businessEnglishObjective: $businessEnglishObjective
    )
  }
`);

export function useDeleteOneOnOneAssignmentPdf() {
  const [mutate, { loading }] = useMutation(
    DeleteOneOnOneAssignmentPdfMutation,
    {
      refetchQueries: [GetAllOneOnOneAssignmentPdfsQuery],
    },
  );

  return {
    loading,
    deleteAssignmentPdf: (input: {
      assignmentNumber: number;
      level: SpeakingClassLevel;
      oneOnOneLessonType: OneOnOneLessonType;
      userGroupId: string;
      businessEnglishObjective?: BusinessEnglishObjective;
    }) => mutate({ variables: input }),
  };
}
